export default __webpack_public_path__ + "static/media/p6.e8a87191.JPG";